// Resolve `url` against the current document and report whether it shares
// the same origin. Used by ajax_status.js (XHR monkey-patch) and request.js
// (fetch/axios wrappers) to keep window.ajax_active — the gate Capybara
// wait_for_ajax relies on — focused on the app's own asynchronous work.
// Cross-origin requests (CDN, consent scripts, analytics) hit unrelated
// infrastructure whose latency cannot signal whether internal state has
// converged, so they are intentionally excluded.
//
// Malformed URLs default to same-origin so the app's own code never
// accidentally bypasses the gate.
const isSameOriginRequest = url => {
  try {
    return new URL(url, window.location.href).origin === window.location.origin;
  } catch {
    return true;
  }
};

export default isSameOriginRequest;
